import { List, Map, Record } from 'immutable';
import { IGrantee, IInvitableUser } from '@opengov/reporting-types';

import { DataTableStatus } from '../../types';

export interface IReportAccessTable {
  accessTableStatus: DataTableStatus;
  currentGrantees: Map<string, IGrantee>;
  temporaryGrantees: Map<string, IGrantee>; // stores ephemeral user access control modifications
  invitableUsers: List<IInvitableUser>;
}

export const ReportAccessTableRecord = Record<IReportAccessTable>({
  accessTableStatus: DataTableStatus.Loading,
  currentGrantees: Map(),
  temporaryGrantees: undefined,
  invitableUsers: List()
});
